import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.0056 10.8005C14.2716 10.8005 16.5372 10.8005 18.8024 10.8005C19.0683 10.7952 19.328 10.8809 19.5388 11.0435C19.7495 11.206 19.8987 11.4358 19.9617 11.6948C20.0277 11.952 20.008 12.2238 19.9055 12.4687C19.8029 12.7136 19.6233 12.9182 19.3939 13.0511C19.201 13.156 18.9836 13.2071 18.7642 13.1992C15.1649 13.1992 11.5657 13.1992 7.96682 13.1992C7.03976 13.1992 6.11269 13.1992 5.18563 13.1992C4.89565 13.2027 4.61469 13.0982 4.39724 12.9058C4.17979 12.7134 4.04137 12.4469 4.0088 12.158C3.93682 11.5285 4.3124 10.9668 4.91458 10.8281C5.02174 10.8069 5.1309 10.7977 5.24009 10.8005C7.49568 10.8005 9.75084 10.8005 12.0056 10.8005Z",
		fill: "currentColor"
	})
});
export default SvgIconMinus;
